import { useEffect, useState } from "react";
import { api } from "../api";
import { timeAgo, haptic } from "../tg";

export function SyncStatusBadge() {
  const [last, setLast] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let alive = true;
    api.health().then((r) => alive && setLast(r.last_loyverse_sync)).catch(() => {});
    const t = setInterval(() => setTick((x) => x + 1), 30_000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  async function refresh() {
    if (busy) return;
    haptic("impact");
    setBusy(true);
    try {
      await api.triggerSync();
      const h = await api.health();
      setLast(h.last_loyverse_sync);
      haptic("success");
    } catch {
      haptic("error");
    } finally {
      setBusy(false);
    }
  }

  // tick triggers re-render so timeAgo updates
  void tick;
  const label = busy ? "đang đồng bộ…" : timeAgo(last);

  return (
    <button
      type="button"
      onClick={refresh}
      disabled={busy}
      className="sync-badge"
      title="Đồng bộ ngay"
    >
      <span className={`dot ${busy ? "warn" : last ? "ok" : "bad"}`} />
      <span className="sync-label">{label}</span>
      <span className="material-symbols-outlined">{busy ? "sync" : "refresh"}</span>
    </button>
  );
}
